export const logo = require('../assets/images/YESMLS_logo.png')
export const loginImage = require('../assets/images/login_bg.png')
export const searchIcon = require('../assets/icons/search.svg')
export const profileImage = require('../assets/images/profile-image.png')
export const profileAvatar = require('../assets/images/profile_avater.png')
export const defaultProfileAvatar = require('../assets/images/user.png')